// plugins/window-scroll.client.ts
import { useWindowScroll, useThrottle } from '@vueuse/core'

export default defineNuxtPlugin((nuxtApp) => {
  const { y }      = useWindowScroll()
  const yThrottled      = useThrottle(y, 100)      // 10 fps
  // const $app         = useAppStore()
  const { $viewport } = nuxtApp               // access injected viewport

  // single watcher – write to store
  // watch(yThrottled, (val) => {
    // const desktop = $viewport.w.value >= 1200
    // io.headerFixed = desktop ? val > 64 : val > 48
  // }, { immediate: true })

  // export both flavours for anyone else
  nuxtApp.provide('windowScroll', {
    y,          // raw 60 fps ref
    yThrottled,      // throttled ref
  })
})